import React from "react";
import { FaShieldAlt, FaLock, FaUserShield, FaFileContract } from "react-icons/fa";

const PrivacyPolicy = () => {
  const brandGreen = "#1ac942";
  const glowStyle = "0 8px 30px rgb(26 201 66 / 33%)";

  return (
    <section style={styles.section}>
      <div style={{ ...styles.container, boxShadow: glowStyle }}>
        
        {/* Header Section */}
        <header style={styles.header}>
          <h1 style={{ ...styles.mainTitle, color: brandGreen }}>
            Privacy Policy
          </h1>
          <p style={styles.subtitle}>Your Security and Trust are our Priority</p>
        </header>

        {/* PRIVACY POLICY SECTION */}
        <div style={styles.contentBlock}>
          <h2 style={styles.sectionHeading}>
          Privacy Policy
          </h2>

          <h3 style={styles.subHeading}>Section 1 – Consent</h3>
          <p style={styles.text}>
            When you purchase <strong>BioSurge</strong>, register on our website, or contact
            us, you consent to the collection and use of your personal information solely
            for order processing, payment verification, delivery, and customer support. 
            Any marketing communication will be sent only after your explicit consent.
          </p>
          <p style={styles.text}>
            You may withdraw your consent at any time: 
            <a href="mailto:biosurge01@gmail.com" style={styles.link}> biosurge01@gmail.com</a>
          </p>

          <h3 style={styles.subHeading}>Section 2 – Disclosure</h3>
          <p style={styles.text}>
            We may disclose your personal information only if required by law, regulatory
            authorities, or if you violate our Terms of Service.
          </p>

          <h3 style={styles.subHeading}>Section 3 – Third-Party Services</h3>
          <p style={styles.text}>
            We use secure third-party partners for payments and shipping. They collect and 
            process your data only to perform services on our behalf. We recommend 
            reviewing their respective privacy policies for more clarity.
          </p>

          <h3 style={styles.subHeading}>Section 4 – Data Security</h3>
          <p style={styles.text}>
            <FaLock style={{ color: brandGreen, marginRight: "5px" }} /> 
            We implement industry-standard security measures, including SSL-encrypted payment
            processing. However, no online storage system can be guaranteed 100% secure.
          </p>

          <h3 style={styles.subHeading}>Section 5 – Age Restriction</h3>
          <p style={styles.text}>
            By using this website, you confirm that you are at least 18 years of age or 
            are accessing the site under the supervision of a parent or legal guardian.
          </p>
        </div>

        {/* TERMS OF SERVICE SECTION */}
        <div style={{ ...styles.contentBlock, marginTop: "50px", borderTop: "1px solid #222", paddingTop: "40px" }}>
          <h2 style={styles.sectionHeading}>
            Terms of Service
          </h2>

          <p style={styles.text}>
            By accessing the BioSurge website, you agree to be bound by these Terms of Service. 
            If you do not agree, please do not use our services.
          </p>

          <h3 style={styles.subHeading}>Section 1 – Online Store Terms</h3>
          <p style={styles.text}>
            Our products are intended for personal wellness only and must not be resold 
            or used for any unlawful purposes. We reserve the right to refuse service 
            or cancel orders at our discretion.
          </p>

          <h3 style={styles.subHeading}>Section 2 – Pricing & Information</h3>
          <p style={styles.text}>
            Product descriptions and prices are subject to change without prior notice. 
            While we strive for accuracy, BioSurge does not guarantee that all website 
            content is error-free or current.
          </p>

          <h3 style={styles.subHeading}>Section 3 – User Feedback</h3>
          <p style={styles.text}>
            Any reviews, suggestions, or feedback submitted to BioSurge may be used 
            for promotional purposes or brand improvement without any obligation.
          </p>
        </div>
<h3 style={styles.subHeading}> BioSurge products are herbal wellness supplements and are not intended to diagnose,
treat, cure, or prevent any disease.</h3>
  

      </div>
    </section>
  );
};

// Internal Styles
const styles = {
  section: {
    padding: "80px 20px",
    backgroundColor: "#000",
    minHeight: "100vh",
    fontFamily: "'Inter', sans-serif",
  },
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    backgroundColor: "#0a0a0a",
    borderRadius: "20px",
    padding: "50px 40px",
    border: "1px solid #1b5e20",
  },
  header: {
    textAlign: "center",
    marginBottom: "50px",
  },
  mainTitle: {
    fontSize: "clamp(26px, 5vw, 42px)",
    fontWeight: "900",
    textTransform: "uppercase",
    margin: 0,
    letterSpacing: "1px",
  },
  subtitle: {
    color: "#666",
    fontSize: "14px",
    marginTop: "10px",
    textTransform: "uppercase",
    letterSpacing: "2px",
  },
  sectionHeading: {
    fontSize: "28px",
    fontWeight: "800",
    color: "#fff",
    marginBottom: "25px",
    display: "flex",
    alignItems: "center",
  },
  subHeading: {
    fontSize: "19px",
    fontWeight: "700",
    color: "#1ac942",
    marginTop: "30px",
    marginBottom: "10px",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#bbb",
    marginBottom: "15px",
  },
  link: {
    color: "#1ac942",
    textDecoration: "underline",
    marginLeft: "5px",
    fontWeight: "600",
  },
  footerNote: {
    marginTop: "60px",
    textAlign: "center",
    color: "#444",
    fontSize: "13px",
    borderTop: "1px solid #111",
    paddingTop: "20px",
  }
};

export default PrivacyPolicy;